import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Link,
  Text,
} from "@chakra-ui/react";
import { TypeFormField } from "../app/content/typegen";
import { FieldBoolean } from "./FieldBoolean";
import { FieldCheckbox } from "./FieldCheckbox";
import { FieldDate } from "./FieldDate";
import { FieldSelect } from "./FieldSelect";
import { FieldText } from "./FieldText";
import { FieldTextarea } from "./FieldTextarea";
import { FieldComponentProps, FieldProps } from "./types";

const componentForType: Record<
  TypeFormField["type"],
  (props: FieldComponentProps) => JSX.Element
> = {
  boolean: FieldBoolean,
  checkbox: FieldCheckbox,
  date: FieldDate,
  select: FieldSelect,
  text: FieldText,
  textarea: FieldTextarea,
};

export function Field(props: FieldProps) {
  const Input = componentForType[props.type];
  const isInvalid = props.isTouched && props.submitCount > 0 && !props.isValid;
  const id = `${props.label}-${props.personIndex || 0}`;
  return (
    <FormControl isInvalid={isInvalid} mt={6}>
      <Flex alignItems="flex-end">
        <FormLabel htmlFor={id}>{props.label}</FormLabel>
        {props.isRequired ? null : (
          <Text color="gray.600" fontSize="sm" pb={1}>
            (optional)
          </Text>
        )}
      </Flex>
      <Input id={id} isInvalid={isInvalid} {...props} />
      <FormErrorMessage>{props.errorMessage}</FormErrorMessage>
      {props.label === "SEPA-Lastschriftmandat erteilen" ? (
        <FormHelperText color="gray.600">
          Lies{" "}
          <Link href="/info/lastschrift" isExternal color="blue.500">
            hier
          </Link>{" "}
          nach, warum wir überhaupt ein Lastschriftmandat brauchen und wann es
          auch möglich ist bar zu zahlen.
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}
